import styled from 'styled-components';

const Footer = styled.footer`
  padding:0px;
  margin: 0;
  font-size:12px;
  background: ${({ theme }) => theme.smokeWhiteGrey};
  .zaggle-logo{
    width: 80%;
    margin-top: 15px;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints[1]}) {
      width: 60%;
      margin: 1rem auto;
    };
  }
  .web-d-none{
    display: none;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints[1]}) {
      display: block;
    };
  }
  .mbl-d-none{
    display: block;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints[1]}) {
      display: none;
    };
  }
  h4 {
    color: ${({ theme }) => theme.davyGrey};
    margin: 0;
    padding: 0px 0px 0px 5px;
    font-size:14px;
    font-weight:600 !important;
    border-left: 2px solid ${({ theme }) => theme.primaryColor};
    padding-right: 15px;
    line-height: 1;
    display: inline-block;
  }
  .contact-p-margin{
    margin-bottom: 5px !important;
  }
  .download-app{
    width: 60% !important;
  }
  .contact-img {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    background: ${({ theme }) => theme.whiteColor};
          box-sizing: border-box;
          padding: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
        }
  .download-card {
    padding: 19px 15px 15px 15px;
    text-align: center;
    position: relative;
    &:before{
      content: "";
      border: ${({ theme }) => theme.ironSideGrey} solid 1px;
      position: absolute;
      right: 15px;
      height: 100px;
      top: 30%;
      @media screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
        display: none;
      };
    }
    b{
      background: ${({ theme }) => theme.greyGoose};
      padding: 9px;
      font-weight: normal;
    }
    h4{
      text-align:left;
      font-weight:normal;
      margin-bottom:15px;
    }
    .store-links {
      text-align: left;
      margin-top: 33px;
      padding-left: 12px;
      @media screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
        margin-top:25px;
        };
      img{
        width:87%;
        margin-bottom:10px;
        @media screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
          width:100%;
          margin-bottom:0px;
        };
      }
      a:nth-child(2) {
        margin-left: 10px;
      }
    }
    img {
      max-width: 100%;
    }
  }
  .footer-links {
    border-bottom: 1px solid #E4E7EB;
  }
  ul{
    margin:0px;
    list-style:none;
    padding:0px;
    font-size:12px;
    margin-top:20px;
    padding-bottom: 10px;
    h4{
        margin-bottom:15px;
        color: #171717;
      }
    li{
      margin-bottom: 10px;
      a{
        text-decoration:none;
        color:#171717;
        img{
          width:87%;
          border-radius: 9px;
          padding: 8px 0px;
          background: #252421;
        }
        &:hover{
          color: #ff0000;
        }
      }
      span{
        padding: 0px 10px;
      }
    }
    @media screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
      padding-left: 1rem;
    };
  }
  .subscribe_panel {
    /* margin: 10px 0 20px 0px; */
    span{
      color: ${({ theme }) => theme.blackColor};
      margin-bottom:10px;
      strong{
        font-weight:normal;
      }
    }
  }
  .flex-end-right {
  display: flex;
  justify-content: flex-end;
  padding: 0;
  margin: 0;
  list-style: none;
}

.flex-center {
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  list-style: none;
}

.font-12-p {
  font-size: 12px !important;
}

@media screen and (max-width: ${({ theme }) => theme.breakpoints[1]}) {
  .flex-end-right {
    justify-content: center;
  }

  .flex-center {
    justify-content: flex-start;
  }
}
.social_media {
  margin: 0px;
  padding: 0px;
  list-style: none;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;

  li {
    margin-bottom: 0px;

    a {
      display: block;
      margin-left: 5px;
      width: 35px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      color: ${({ theme }) => theme.secondaryColor};
      font-size: 14px;

      img {
        background-color: transparent;
        width: 32px;
        height: 32px;
        object-fit: contain;
      }

      @media screen and (max-width: ${({ theme }) => theme.breakpoints[1]}) {
        margin-top: 0px;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    justify-content: center;
  }
}

@media screen and (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    .mbl-text-center{
      text-align: center !important;
    }
    .mbl-margin-b-2{
      margin-bottom: 20px;
    }
  }
`;

export default Footer;



// WEBPACK FOOTER //
// client/components/FooterNew/style.js